import React from 'react';
import useBusinessGuard from '../../../../hooks/useBusinessGuard';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useDispatch, useSelector } from 'react-redux';
import {
  AddQuickServicesListing,
  AddMedia,
  getQuickServicesCategory,
  getQuickServicesListing,
  UpdateQuickServicesListing,
} from './../../../../Redux/Actions/UserAction';
import { FilledInput } from '@material-ui/core';
import Sidebar from '../../../common/Sidebar/Sidebar';
import MapModal from '../../../common/Modal/MapModel';
import LogoCropModal from '../../../common/Modal/LogoCropModal';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';
import Swal from 'sweetalert2';
import { sanitizeWhatsAppFields } from '../../../../utils/sanitizeWhatsApp';

const QuickServicesBusiness = () => {
  const { t } = useTranslation();
  const home = useSelector((state) => state.home);
  const categorylist = home?.getCategoryList;
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const [ImageLogo, setImageLogo] = useState({
    sImage: '',
  });
  const [ImageBlob, setImageBlob] = useState({ blob: '' });
  // Cropper state: { src, name } of the just-picked image, shown in the modal.
  const [cropSrc, setCropSrc] = useState(null);
  const [cropName, setCropName] = useState('');
  // Additional phone numbers beyond the primary phone + whatsapp. Each entry is
  // { countryCode, mobileNumber }. Appended to mobileNumbers on submit.
  const [extraPhones, setExtraPhones] = useState([]);
  const addExtraPhone = () =>
    setExtraPhones((p) => [...p, { countryCode: '+965', mobileNumber: '' }]);
  const removeExtraPhone = (i) =>
    setExtraPhones((p) => p.filter((_, idx) => idx !== i));
  const updateExtraPhone = (i, key, value) =>
    setExtraPhones((p) =>
      p.map((row, idx) => (idx === i ? { ...row, [key]: value } : row))
    );
  const [mapModalOpen, setMapModalOpen] = useState(false);

  const dispatch = useDispatch();

  // One business per account: redirect if the user already owns a
  // different business instead of failing this add-form on save.
  useBusinessGuard('CAR13');

  const getMybusiness = home?.getMybusiness;
  const getQuickServicesList = home?.getQuickServicesList;

  // The owner's business id can arrive two ways after a reload: from
  // sessionStorage (set by the Header once /business/my resolves) or directly
  // from the Redux getMybusiness object. Prefer whichever is available.
  const ownerBid =
    (getMybusiness?.businessId && String(getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');
  const validBid =
    ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null' && ownerBid !== '';

  const [QuickServices, setQuickServices] = useState([]);

  useEffect(() => {
    // Fetch the owner's OWN business as soon as we know its id. Runs again when
    // the id becomes available post-reload (Header resolves it asynchronously),
    // which fixes the blank form after creating a business.
    if (validBid) {
      dispatch(getQuickServicesListing(ownerBid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerBid]);

  useEffect(() => {
    // Only keep the owner's OWN business, identified by BusinessId — never the
    // shared customer listing (which holds every vendor and would otherwise
    // show the first vendor's data here). Compare as strings so a numeric
    // businessId still matches the sessionStorage/Redux id.
    // [FB2-#19] The quickServiceOwner listing records identify themselves by
    // `quickServiceOwnerId` — there is NO `businessId` field on them. The old
    // check compared `.businessId` (always undefined) so it NEVER matched and
    // the form stayed blank after saving. Match on quickServiceOwnerId (the id
    // we fetched with), with businessId as a fallback for safety.
    const recId =
      getQuickServicesList?.[0]?.quickServiceOwnerId ??
      getQuickServicesList?.[0]?.businessId;
    if (
      getQuickServicesList?.length &&
      validBid &&
      String(recId) === String(ownerBid)
    ) {
      setQuickServices(getQuickServicesList);
    } else if (validBid && getQuickServicesList?.length) {
      // Listing present but not our business yet — clear.
      setQuickServices([]);
    }
    // [FB2-#19] Re-run when ownerBid resolves too. After a re-login the Header
    // resolves BusinessId asynchronously; if the listing arrived first, the
    // owner-id comparison failed once and (with only [getQuickServicesList] in
    // the deps) never re-evaluated — so the company form stayed blank. Adding
    // ownerBid re-checks once the id is known and prefills the form.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getQuickServicesList, ownerBid]);

  const [QuickServicesData, setQuickServicesData] = useState({
    quickServiceOwnerName: '',
    category: '',
    mobileNumberCountryCode: '+965',
    mobileNumber: '',
    whatsAppNumberCountryCode: '+965',
    whatsAppNumber: '',
    mobileNumbers: [
      {
        countryCode: '+965',
        mobileNumber: '',
      },
    ],
    location: '',
    about: '',
    gps: {
      lat: '12.001',
      long: '34.113',
    },
    website: '',
    socialMedia: {
      FACEBOOK: '',
      SNAPCHAT: '',
      INSTAGRAM: '',
      YOUTUBE: '',
      LINKEDIN: '',
      TWITTER: '',
    },
    mediaIds: {
      LOGO: [''],
    },
  });

  useEffect(() => {
    if (QuickServices?.length) {
      const gps =
        typeof QuickServices?.[0]?.gps === 'string'
          ? JSON.parse(QuickServices?.[0]?.gps)
          : QuickServices?.[0]?.gps;
      const socialMedia =
        typeof QuickServices?.[0]?.socialMedia === 'string'
          ? JSON.parse(QuickServices?.[0]?.socialMedia)
          : QuickServices?.[0]?.socialMedia;
      const logo = QuickServices?.[0]?.businessMedia?.find(
        (media) => media.mediaType === 'LOGO'
      )?.media;
      setQuickServicesData({
        quickServiceOwnerName: QuickServices?.[0]?.quickServiceOwnerName,
        category: QuickServices?.[0]?.category,
        mobileNumberCountryCode: QuickServices?.[0]?.mobileNumberCountryCode,
        mobileNumber: QuickServices?.[0]?.mobileNumber,
        whatsAppNumberCountryCode:
          QuickServices?.[0]?.whatsAppNumberCountryCode,
        whatsAppNumber: QuickServices?.[0]?.whatsAppNumber,
        location: QuickServices?.[0]?.location,
        about: QuickServices?.[0]?.about,
        gps: {
          lat: gps?.lat,
          long: gps?.long,
        },
        website: QuickServices?.[0]?.website,
        socialMedia: {
          FACEBOOK: socialMedia?.FACEBOOK,
          SNAPCHAT: socialMedia?.SNAPCHAT,
          INSTAGRAM: socialMedia?.INSTAGRAM,
          YOUTUBE: socialMedia?.YOUTUBE,
          LINKEDIN: socialMedia?.LINKEDIN,
          TWITTER: socialMedia?.TWITTER,
        },
        mediaIds: {
          LOGO: [logo?.mediaId],
        },
      });
      setImageBlob({
        blob: logo?.path,
      });

      // Load any saved numbers beyond the first two (phone + whatsapp) into the
      // additional-phones editor so they show up and can be edited.
      const _savedNums = QuickServices?.[0]?.mobileNumbers;
      if (Array.isArray(_savedNums) && _savedNums.length > 2) {
        setExtraPhones(
          _savedNums.slice(2).map((n) => ({
            countryCode: n?.countryCode || '+965',
            mobileNumber: n?.mobileNumber || '',
          }))
        );
      }

      // Sync the prefilled values into react-hook-form too. The inputs are
      // controlled by state, but RHF only tracks values entered through its own
      // onChange — without this, a prefilled form would fail validation on
      // submit ("Business name / Phone number is required") even though the
      // fields are visibly filled (e.g. when the owner edits only the logo).
      setValue('quickServiceOwnerName', QuickServices?.[0]?.quickServiceOwnerName || '', {
        shouldValidate: true,
      });
      setValue('mobileNumber', QuickServices?.[0]?.mobileNumber || '', {
        shouldValidate: true,
      });
      setValue('whatsAppNumber', QuickServices?.[0]?.whatsAppNumber || '', {
        shouldValidate: true,
      });
    }
  }, [QuickServices]);

  useEffect(() => {
    dispatch(getQuickServicesCategory());
  }, [dispatch]);

  function handleChange(e) {
    const { name, value } = e.target;
    setQuickServicesData((user) => ({ ...user, [name]: value }));
  }
  const mediaChange = (e) => {
    setQuickServicesData({
      ...QuickServicesData,
      socialMedia: {
        ...QuickServicesData.socialMedia,
        [e.target.name]: e.target.value,
      },
    });
  };

  const imageIds = (e) => {
    setQuickServicesData({
      ...QuickServicesData,
      mediaIds: {
        ...QuickServicesData.mediaIds,
        [e.target.name]: e.target.value[0],
      },
    });
  };

  const handleUploadImage = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate: must be an image, and within a sane size limit
    if (!file.type || !file.type.startsWith('image/')) {
      Swal.fire({
        title: 'Invalid file',
        text: 'Please upload an image file (JPG, PNG, etc.).',
        icon: 'error',
      });
      event.target.value = '';
      return;
    }
    const MAX_MB = 12;
    if (file.size > MAX_MB * 1024 * 1024) {
      Swal.fire({
        title: 'Image too large',
        text: `Please upload an image smaller than ${MAX_MB} MB.`,
        icon: 'error',
      });
      event.target.value = '';
      return;
    }

    // Load the picked image and open the cropper modal. The owner frames the
    // logo in a square; the cropped, compressed JPEG is uploaded on Apply.
    const reader = new FileReader();
    reader.onload = (ev) => {
      setCropName(file.name || 'logo');
      setCropSrc(ev.target.result);
    };
    reader.readAsDataURL(file);
    // Allow re-picking the same file later.
    event.target.value = '';
  };

  // Upload a cropped square logo (called by the cropper modal's Apply button).
  const uploadCroppedLogo = (result) => {
    setCropSrc(null);
    if (!result || !result.file) return;
    setImageLogo({ selectedFile: result.file });
    // The preview <img> reads ImageBlob.blob, so wrap the data URL in { blob }
    // (same shape the prefill uses) — otherwise the cropped image won't show.
    if (result.preview) setImageBlob({ blob: result.preview });
    const formData = new FormData();
    formData.append('media', result.file);
    // silent: the inline preview is the confirmation, so no success popup.
    pendingLogoUploadRef.current = true;
    dispatch(AddMedia({ formData, silent: true }));
  };

  const pendingLogoUploadRef = useRef(false);
  /* [CF 2026-08-11] The uploaded logo id arrives asynchronously in the
     `[counter]` effect below, but TWO other effects (the prefill and the
     mobileNumbers rebuild) also call setState with their own stale snapshot of
     this object — either can drop the fresh LOGO id before the form is
     submitted, and the save then re-sends the OLD id, which the owner sees as
     "the logo did not change". The ref is written the instant the upload
     resolves and is applied again at submit time, so it cannot be clobbered. */
  const logoIdRef = useRef(null);
  const counter = useSelector((state) => state.home.AddMediaList);
  console.log('useSelecter ', counter);
  /* [CF 2026-08-09 #18] `home.AddMediaList` is a GLOBAL redux slot written by
     every media upload anywhere in the app, and nothing ever clears it. This
     effect therefore also fired on MOUNT, off whatever the last upload had
     left behind, silently stamping the PREVIOUS company's logo id into this
     form — save it and that company's logo came back, which is the "updating
     one company's logo reverts the other one" report. Consume the slot only
     when THIS page actually started an upload; same guard the `*Banner.js`
     screens already carry as `pendingUploadRef`. */
  useEffect(() => {
    if (!pendingLogoUploadRef.current) return;
    pendingLogoUploadRef.current = false;
    console.log('hellow ', counter);
    if (counter !== undefined) {
      const logoid = counter?.data?.response?.media[0]?.mediaId;
      logoIdRef.current = logoid;
      console.log('logoid', logoid);

      setQuickServicesData({
        ...QuickServicesData,
        mediaIds: {
          ...QuickServicesData.mediaIds,
          LOGO: [logoid],
        },
      });
    }
  }, [counter]);

  useEffect(() => {
    setQuickServicesData({
      ...QuickServicesData,
      mobileNumbers: [
        {
          countryCode: QuickServicesData.mobileNumberCountryCode,
          mobileNumber: QuickServicesData.mobileNumber,
        },
        {
          countryCode: QuickServicesData.whatsAppNumberCountryCode,
          mobileNumber: QuickServicesData.whatsAppNumber,
        },
      ],
    });
  }, [
    QuickServicesData.mobileNumberCountryCode,
    QuickServicesData.mobileNumber,
    QuickServicesData.whatsAppNumberCountryCode,
    QuickServicesData.whatsAppNumber,
  ]);

  const datasubmit = () => {
    // Append filled-in additional phone numbers to the primary phone + whatsapp
    // entries already built in QuickServicesData.mobileNumbers.
    const _extra = extraPhones.filter(
      (p) => p.mobileNumber && String(p.mobileNumber).trim()
    );
    const _payload = sanitizeWhatsAppFields({
      ...QuickServicesData,
      mobileNumbers: [...(QuickServicesData.mobileNumbers || []), ..._extra],
    });
    if (logoIdRef.current) {
      _payload.mediaIds = {
        ..._payload.mediaIds,
        LOGO: [logoIdRef.current],
      };
    }
    console.log('this is quick service data', QuickServicesData);
    if (QuickServices?.length > 0) {
      dispatch(UpdateQuickServicesListing(_payload));
    } else {
      dispatch(AddQuickServicesListing(_payload));
    }
  };
  const ResetHendler = () => {
    reset();
    setQuickServicesData({
      quickServiceOwnerName: '', category: '', mobileNumberCountryCode: '+965', mobileNumber: '',
      whatsAppNumberCountryCode: '+965', whatsAppNumber: '',
      mobileNumbers: [{ countryCode: '+965', mobileNumber: '' }],
      location: '', about: '', gps: { lat: '', long: '' }, website: '',
      socialMedia: { FACEBOOK: '', SNAPCHAT: '', INSTAGRAM: '', YOUTUBE: '', LINKEDIN: '', TWITTER: '' },
      mediaIds: { LOGO: [''] },
    });
    setImageLogo({ selectedFile: '' });
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-quick-services-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-quick-services-parts',
      label: t('Manage Services'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-quick-services-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-quick-services-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  // Close map modal
  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  const handleLocationSelect = (location) => {
    console.log(location);

    setQuickServicesData({
      ...QuickServicesData,
      location: location.address,
      gps: {
        lat: location.lat,
        long: location.long,
      },
    });
  };

  const isPaymentPlanActive = sessionStorage.getItem('paymentPlan');

  return (
    <div>
      <CommonBusinessHeader
        dataList={getQuickServicesList}
        getNameKey="quickServiceOwnerName"
      />
      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2>{t('Manage Business')}</h2>

              <form onSubmit={handleSubmit(datasubmit)}>
                <div class="form-group">
                  <label for="g-mb-business-name">{t('Business Name')}</label>
                  <input
                    {...register('quickServiceOwnerName', {
                      required: t('This field is required'),
                      minLength: {
                        value: 4,
                        message: t(
                          'Business Name should be minimum  4 character'
                        ),
                      },
                      // pattern: {
                      // 	value: /^[a-zA-Z0-9](_(?!(\.|_))|\.(?!(_|\.))|[a-zA-Z0-9]){6,18}[a-zA-Z0-9]$/,
                      // 	message:
                      // 		'username can only use letters,numbers, minimum length is 6 characters',
                      // },
                    })}
                    name="quickServiceOwnerName"
                    value={QuickServicesData.quickServiceOwnerName}
                    onChange={handleChange}
                    type="text"
                    className={classNames('form-control', {
                      'is-invalid': errors.quickServiceOwnerName,
                    })}
                    id="g-mb-business-name"
                    placeholder={t("Business Name")}
                  />
                  {errors.quickServiceOwnerName && (
                    <p className="invalid-feedback">
                      {errors.quickServiceOwnerName.message}
                    </p>
                  )}
                </div>

                <div class="form-group">
                  <label>{t('Business Logo Image')}</label>
                  <div class="row align-items-center ">
                    <div class="col-auto">
                      <div class=" row-cols-7">
                        <img
                          style={{
                            height: '7rem',
                            width: '7rem',
                            borderRadius: '7rem',
                            objectFit: 'cover',
                            border: '1px solid #e3e3e3',
                            background: '#f7f7f7',
                          }}
                          class="profile-pic img-fluid "
                          // src='assets/images/camera.jpg'
                          // src='/Screenshot (4).png'
                          src={
                            ImageBlob.blob
                              ? ImageBlob.blob
                              : 'assets/images/camera.jpg'
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="p-image">
                        <label
                          class="btn btn-outline-secondary upload-button btn-sm"
                          for="files"
                        >
                          {t('Upload Logo image')}
                        </label>
                        <input
                          type="file"
                          id="files"
                          accept="image/*"
                          onChange={handleUploadImage}
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div class="form-group">
									<label>Business Logo Image</label>
									<div class="row align-items-center">
										<div class="col-auto">
											<div class="circle">
												<img
													class="profile-pic img-fluid"
													src="assets/images/camera.jpg"
													alt=""
												/>
											</div>
										</div>
										<div class="col-auto">
											<div class="p-image">
												<a
													class="btn btn-outline-secondary upload-button btn-sm"
													href="javascript:void(0);"
													role="button"
												>
													Upload Logo image
												</a>
												<input class="file-upload" type="file" accept="image/*" />
											</div>
										</div>
									</div>
								</div> */}

                <div class="form-group">
                  <label for="g-mb-phone-number">{t('Phone Number')}</label>
                  <div class="row">
                    <div class="col-4">
                      <select
                        class="form-control"
                        name="mobileNumberCountryCode"
                        value={QuickServicesData.mobileNumberCountryCode}
                        onChange={handleChange}
                      >
                        <option value="">{t('Country Code')}</option>
                        <option value="+965">+965</option>
                      </select>
                    </div>
                    <div class="col-8">
                      <input
                        {...register('mobileNumber', {
                          required: t('This field is required'),
                          pattern: {
                            value: /^\d{8}$/,
                            message:
                              'please enter a valid 8-digit phone number ',
                          },
                        })}
                        name="mobileNumber"
                        value={QuickServicesData.mobileNumber}
                        onChange={handleChange}
                        type="tel"
                        className={classNames('form-control', {
                          'is-invalid': errors.mobileNumber,
                        })}
                        id="g-mb-phone-number"
                        placeholder={t("Phone Number")}
                      />
                      {errors.mobileNumber && (
                        <p className="invalid-feedback">
                          {errors.mobileNumber.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="g-mb-whatsApp-number">
                    {t('WhatsApp Number')} <small>(Optional)</small>
                  </label>
                  <div class="row">
                    <div class="col-4">
                      <select
                        class="form-control"
                        name="whatsAppNumberCountryCode"
                        value={QuickServicesData.whatsAppNumberCountryCode}
                        onChange={handleChange}
                      >
                        <option value="">{t('Country Code')}</option>
                        <option value="+965">+965</option>
                      </select>
                    </div>
                    <div class="col-8">
                      <input
                        {...register('whatsAppNumber', {
                          // required: 'this field is requerd',
                          pattern: {
                            value: /^\d{8}$/,
                            message:
                              'please enter a valid 8-digit whatsApp number ',
                          },
                        })}
                        name="whatsAppNumber"
                        value={QuickServicesData.whatsAppNumber}
                        onChange={handleChange}
                        type="tel"
                        className={classNames('form-control', {
                          'is-invalid': errors.whatsAppNumber,
                        })}
                        id="g-mb-whatsApp-number"
                        placeholder={t("WhatsApp Number")}
                      />
                      {errors.whatsAppNumber && (
                        <p className="invalid-feedback">
                          {errors.whatsAppNumber.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>
                    {t('Additional Phone Numbers')}{' '}
                    <small>({t('Optional')})</small>
                  </label>
                  {extraPhones.map((phone, idx) => (
                    <div class="row" key={idx} style={{ marginBottom: '8px' }}>
                      <div class="col-4">
                        <select
                          class="form-control"
                          value={phone.countryCode}
                          onChange={(e) =>
                            updateExtraPhone(idx, 'countryCode', e.target.value)
                          }
                        >
                          <option value="+965">+965</option>
                        </select>
                      </div>
                      <div class="col-7">
                        <input
                          type="tel"
                          inputMode="numeric"
                          class="form-control"
                          value={phone.mobileNumber}
                          placeholder={t('Phone Number')}
                          onChange={(e) =>
                            updateExtraPhone(idx, 'mobileNumber', e.target.value)
                          }
                        />
                      </div>
                      <div class="col-1 px-0">
                        <button
                          type="button"
                          class="btn btn-outline-danger btn-block"
                          title={t('Remove')}
                          onClick={() => removeExtraPhone(idx)}
                        >
                          &times;
                        </button>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    onClick={addExtraPhone}
                  >
                    + {t('Add phone number')}
                  </button>
                </div>

                {/* <div class="form-group">
                  <label for="g-mb-business-category">
                    {t('Business Category')}
                  </label>
                  <select
                    class="form-control"
                    id="g-mb-business-category"
                    name="category"
                    value={QuickServicesData.category}
                    onChange={handleChange}
                  >
                    <option>Select Business Category</option>
                    {categorylist !== undefined && categorylist.length > 0
                      ? categorylist.map((x) => {
                          // console.log(x);
                          return (
                            <option value={x.quickServiceId}>
                              {t(x.quickService || '')}
                            </option>
                          );
                        })
                      : ''}
                  </select>
                </div> */}

                <div class="form-group">
                  <label for="g-mb-about-company">
                    {t('About the Company')} <small>({t('Optional')})</small>
                  </label>
                  <textarea
                    name="about"
                    value={QuickServicesData.about}
                    onChange={handleChange}
                    class="form-control"
                    id="g-mb-about-company"
                    rows="2"
                  ></textarea>
                </div>

                <div class="form-group">
                  <label for="g-mb-location-map">
                    {t('Select Location on Map')}
                  </label>
                  <div className="input-group">
                    <input
                      name="location"
                      value={QuickServicesData.location}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      id="g-mb-location-map"
                      placeholder={`${QuickServicesData?.location}`}
                      readOnly
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={handleOpenMap}
                      >
                        <img
                          src="assets/images/icons/map-marker.svg"
                          alt="Map"
                          style={{ height: '20px', width: '20px' }}
                        />
                      </button>
                    </div>
                  </div>
                  <small className="form-text text-muted">
                    {t(
                      'Click to open the map and select your business location'
                    )}
                  </small>
                </div>
                <MapModal
                  open={mapModalOpen}
                  handleClose={handleCloseMap}
                  onLocationSelect={handleLocationSelect}
                  currentLocation={{
                    lat: QuickServicesData.gps?.lat,
                    long: QuickServicesData.gps?.long,
                    address: QuickServicesData?.location,
                  }}
                />

                <LogoCropModal
                  open={!!cropSrc}
                  imageSrc={cropSrc}
                  fileName={cropName}
                  onCancel={() => setCropSrc(null)}
                  onApply={uploadCroppedLogo}
                />

                <div class="form-group">
                  <label for="g-mb-website">
                    {t('Website')} <small>(Optional)</small>
                  </label>
                  <input
                    name="website"
                    value={QuickServicesData.website}
                    onChange={handleChange}
                    type="text"
                    class="form-control"
                    id="g-mb-website"
                    placeholder={t("Website")}
                  />
                </div>

                <div class="form-group">
                  <h5>{t('Add Social Media Channels')}</h5>
                  <ul
                    class="list-inline mb-0 social-media-channel "
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <li
                      class="list-inline-item mb-2 "
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/facebook.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="FACEBOOK"
                        value={QuickServicesData?.socialMedia?.FACEBOOK}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('facebook')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/instagram.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="INSTAGRAM"
                        value={QuickServicesData?.socialMedia?.INSTAGRAM}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('instagram')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/twitter.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="TWITTER"
                        value={QuickServicesData?.socialMedia?.TWITTER}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('twitter')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/youtube.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="YOUTUBE"
                        value={QuickServicesData?.socialMedia?.YOUTUBE}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('youtube')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/linkedin.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="LINKEDIN"
                        value={QuickServicesData?.socialMedia?.LINKEDIN}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('linkedin')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/snapchat.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="SNAPCHAT"
                        value={QuickServicesData?.socialMedia?.SNAPCHAT}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('snapchat')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/googleplus.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="googleplus"
                        value={QuickServicesData?.socialMedia?.googleplus}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('googleplus')}
                      />
                    </li>
                  </ul>
                </div>

                <div class="row">
                  <div class="col-6">
                    <button
                      type="reset"
                      class="btn btn-secondary btn-block"
                      onClick={ResetHendler}
                    >
                      {t('Reset')}
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      type="submit"
                      // to='/sp-garages-packages'
                      class="btn btn-warning btn-block"
                      // href='sp-garages-manage-business-packages.html'
                      // role='button'
                      onSubmit={handleSubmit(datasubmit)}
                    >
                      {QuickServices?.length ? t('Update') : t('Submit')}
                    </button>
                    {/* {isPaymentPlanActive == 'true' ? (
                    ) : (
                      <a
                        class="btn btn-warning btn-block"
                        href="#/manage-package"
                        role="button"
                      >
                        Buy Subscription
                      </a>
                    )} */}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickServicesBusiness;
